import { Guid } from "@syncfusion/ej2/pdf-export";
import { EDI271AAADetailBO, EDI271LoopDetailBO } from "../eligibility270/eligibility270.model";
export class ClientBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  firstName: string;
  lastName: string;
  middleName: string;
  status_Name: string;
  userName: string;
  dOB: string | null;
  weight: number | null;
  aKA: string;
  isEin: string;
  medicaid: string;
  medicare: string;
  street: string;
  street2: string;
  apt: string;
  phone1: string;
  phone2: string;
  county: string;
  city: string;
  age: number | null;
  state: string;
  zipCode: string;
  ssn: string;
  email: string;
  requireEVV: boolean;
  internalId: string;
  pClientId: string;
  insuranceNo: string;
  billto_Name: string;
  billto_Street: string;
  billto_City: string;
  billto_State: string;
  billto_Zipcode: string;
  billto_Phone: string;
  billto_Email: string;
  mA_PMI: string;
  county_fiscalResponsibility: string;
  locationId: string;
  priorityStatusLid: string | null;
  genderLid: string;
  assessmentRatingLid: string | null;
  pCATypeLid: string | null;
  typeofWaiverLid: string | null;
  isEinLid: string | null;
  statusLid: string;
  agencyId: string;
  loginUserId: string | null;
  locationName: string;
  name: string;
  gender_Name: string;
  assessmentRatingName: string;
  pCATypeName: string;
  typeofWaiverName: string;
  priorityStatusName: string;
  languageLid: any[] = [];
  pmi: string;
  isMNChoiceAssessment:boolean=false;
 // cfssModel : any[] = [];
  paySourceLid:string;
  cfssModel:string;
  isHomelessClient: boolean=false;
  employeeNames:string;
  clientTypeLid :  string;
  referralDate : string;
  eventConfirmation : boolean;
}

export class ClientReturnBO {
  clientId: string;
  errorList: string[];
}
export class QPfilter {
  Client: number = 0;
  QPEMP: number = 0;
  Status: string = "00000000-0000-0000-0000-000000000000";
}
export class GetClientEmployeeRelationshipBO {
  id: string ="00000000-0000-0000-0000-000000000000";
  clientId: Guid;
  employeeId: Guid;
  statusLid: string;
  employeeName: string;
  clientName: string;
  
}

export class EditDetailsClient {
  newclient = false;
  isCheckClientView: boolean | null;
  isView: boolean = false;
  isEdit: boolean = false;
  isnewClient: boolean;
  isEditClient: boolean = false;
  clientId: string = "00000000-0000-0000-0000-000000000000";
  iscounsumer: boolean = false;
  isaid: boolean = false;
  isaidandConsumer: boolean = false;
  consumerId: string = "00000000-0000-0000-0000-000000000000";
  clientData: ClientBO = new ClientBO();
  isclientfilterEnable: boolean = false;
  addpreviousdata: any;
  isconsumeraddpreviousdata: boolean = false;
  basicCareId: string = "00000000-0000-0000-0000-000000000000";
  isEditbasicPlan: boolean = false;
  iclsCareId: string = "00000000-0000-0000-0000-000000000000";
  isEditiclsPlan: boolean = false;
  rowIndex: string | null;
  isHomeMakingCarePlanAdvanced: boolean | null;
  isComprehensiveNew: boolean = false;
  homeCareId: string = "00000000-0000-0000-0000-000000000000";
  isEditHomePlan: boolean = false;
   // ✅ ADD THIS PROPERTY
  ClientfilterDetails?: GetListBase;  
}


export class ResponsibleInfoLst {
  name: string;
  email: string;
  alternatePhoneNumber: string;
  city: string;
  county: string;
  fax: string;
  phoneNumber: string;
  relationship: string;
  state: string;
  street: string;
  zipCode: string;
}

export class EmergencyContactInfoLst {
  alternatePhoneNumber: string;
  city: string;
  county: string;
  email: string;
  fax: string;
  name: string;
  phoneNumber: string;
  relationship: string;
  state: string;
  street: string;
  zipCode: string;
}
export class CaregiverInfoLst {
  age: string;
  apt: string;
  city: string;
  county: string;
  email: string;
  name: string;
  phone1: string;
  phone2: string;
  steet: string;
  street: string;
  zipcode: string;
}
export class OfficeCaseManagerInfoLst {
  alternate_Fax: string;
  county: string;
  email: string;
  fax: string;
  name: string;
  phone: string;
}

////contact tab Bo////
export class ContactInfoLst {
  id: string = "00000000-0000-0000-0000-000000000000";
  name: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  county: string;
  phoneNumber: string;
  alternatePhoneNumber: string;
  fax: string;
  email: string;
  contactTypeLid: string;
  relationshipLid: string | null;
  phoneCarrierLid: string | null;
  employeeId: string | null;
  clientId: string;
  contactTypeName: string;
  relationshipName: string;
  phoneCarrierName: string;
  showAdditionalDetails: boolean = false;
}
export class clientFilter {
  clientStatus: number = 0;
}

export class getClient {
  searchColumn: string = "Name";
  searchText: string = "";
  orderColumn: string = "Name";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  agencyId: string;
  statusLid: string;
  employeeTypeLi: string;
  field: string = "name";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  locationLid: string = "00000000-0000-0000-0000-000000000000";
  insuranceNo: string;
  cfssModel : any[] = [];
  typeofWaiverLid: string | null;
  typeofWaiverName: string;
   QpEmployeeId:string ="00000000-0000-0000-0000-000000000000"
   employeeNames:string;
  }
export class GetUserBo {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  name: string;
}

export class onBoardingListBO {
  docToOnboarding: boolean = false;
  datalist: any
  clientid: string
}

export class GetListBase {
  
  searchColumn: string = "Name";
  searchText: string = "";
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "name";
  orderType: string = "asc";
  type: string = "string";
  field: string = "name";
  operator: string = "contains";
  value: string = "";
  matchCase: boolean = false;
  agencyID: string | null;
  locationID: string | null;
  clientID: string | null;
  statusLId: string | null;
  employeeTypeLid: string | null;
  employeeID: string | null;
  monitorId: string | null;
  cfssModel : any[] = [];
  typeofWaiverLid: string | null;
  typeofWaiverName: string;
  insuranceNo: string;
  PaySourceLid : string;
  QpEmployeeId:string ="00000000-0000-0000-0000-000000000000"
  employeeNames:string;
  authStatus:string ;
  isCompleted : string;
  languageLIds:string[];
 }

export class GetListForAgencyBase extends GetListBase {

}

export class GetListForLocationBase extends GetListForAgencyBase {
}

export class GetListForClientBase extends GetListForLocationBase {

}

export interface GetListForEmployeeBase extends GetListForLocationBase {

}

export class GetMenuFunctionalityListBO extends GetListForAgencyBase {
  sideMenuId: string;
}

export class ClientAuthBO {
  Id: string;
}

export class GetAuthListBo {

  orderColumn: string = "payorName";

  type: string = "string";
  field: string = "payorName";
  currentpageno: number = 1;
  orderType: string = "asc";
  pageitem: number = 10;
  operator: string = "startswith";
  value: string;
  matchCase: boolean = false;
  agencyID: string | null;
  locationID: string | null;
  statusLid: string | null;
  employeeId: string | null;
  clientId: string | null;
  state: string;
  relationshipId: string | null;
}

export class saveupdateAuthorizationBo {
  id: string = "00000000-0000-0000-0000-000000000000";
  startDate: string = "";
  endDate: string;
  authTypelid: string;
  groupPayorId: string;
  serviceId: string;
  serviceDescription: string;
  totalhours: number;
  totalNoWeeksOrMonths: number;
  rate: number;
  usedAmt: number | null;
  doesPtoApply: boolean;
  ServiceArrayList: any = [];
  payrollTaxApply: boolean;
  clientId: string;
  isCreate: boolean = false;
  insuranceNo: string;
  serviceAgreementNumber: string;
  icD10Code: string;
  isTaxable: boolean;
  companyId: string;
  authNote: string;
}

export class disablePortalBO {
  empId: string;
}

export class SendToPortalBO {
  clientId: string;
  agencyNote: string;
  portalLink: string;
  statusLid: string;
  username: string;
  agencyid: string;
  password:string | null;
}

export class EmployerEmployeeRelationshipTaxPercentBO {
  id: "00000000-0000-0000-0000-000000000000";
  employerEmployeeRelationshipTaxId: string;
  employerEmployeeRelationshipTaxName: string;
  employerEmployeeRelationshipName: string;
  employerEmployeeRelationshipId: string;
  effectiveDate: string;
  percent: number;
  agencyId: string;
  clientId: string | null;
  cliEmpName: string;

}

export class GetListBO {
  orderColumn: string = "EmployerEmployeeRelationshipName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  agencyID: string;
  field: string = "EmployerEmployeeRelationshipName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  type: string = "string";
  clientId: string | null;
}

export class WhereCondition {
  field: string = "employerEmployeeRelationshipName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}

export class notesemit {
  isView: boolean = false;
  isEdit: boolean = false;
}

export class functionpermission {
  clientcreate: boolean = true;
  clientupdate: boolean = true;
  clientdelete: boolean = true;
  authorizationcreate: boolean = true;
  authorizationupdate: boolean = true;
  contactcreate: boolean = true;
  contactupdate: boolean = true;
  contactdelete: boolean = true;
  releationshipcreate: boolean = true;
  releationshipdelete: boolean = true;
  releationshipupdate: boolean = true;
  documentcreate: boolean = true;
  documentupdate: boolean = true;
  documentdelete: boolean = true;
  clientbudgetcreate: boolean = true;
  clientbudgetupdate: boolean = true;
  clientnotescreate: boolean = true
  clientnotesupdate: boolean = true
  clientnotesdelete: boolean = true
  startofcarecreate: boolean = true;
  certificationcreate: boolean = true;
  certificationdelete: boolean = true;
  certificationupdate: boolean = true;
  sdpcreate: boolean = true;
  sdpupdate: boolean = true;
  sdpdelete: boolean = true;
  sdpapprove: boolean = true;

}

// export class EditDetailsAuthorization {
//   isView: boolean = false;
//   isEdit: boolean = false;
//   isEditAuthorization: boolean = false;
//   AuthorizationId: string = '00000000-0000-0000-0000-000000000000';
//   AuthorizationData: saveupdateAuthorizationBo = new saveupdateAuthorizationBo();
//   ClientId: string = '00000000-0000-0000-0000-000000000000';
//   type: string = '';
// }
export class ZipcodeDetailBO {
  id: string = '00000000-0000-0000-0000-000000000000';
  agencyId: string = '00000000-0000-0000-0000-000000000000';
  county: string;
  state: string;
  city: string;
  zipcode: string;
}

export class AuthorizationFilterBo {
  TypeFilter: string;
}

export class AuthListBO {
  orderColumn: string = "id";
  orderType: string = "desc";
  pageitem: number = 10;
  clientId: string;
  ages: number;
  client: string;
  currentpageno: number = 1;
  field: string = "companyName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  state: string = "active";
}
export class IsViewEditSchedule {
  isView: boolean;
  isEdit: boolean;
  isAdd: boolean;
  // isEditCompany:boolean;
  editScheduleId: number;
  AgencyId: string;
  ClientId: string;
  Data: null;
}
export class ServiceDetailBO {
  serviceDescription: string;
  netRate: number | null;
  ucRate: number | null;
  authLimitType: string;
}
export class GetImportAuthorizationBo {
  clientId: string = '00000000-0000-0000-0000-000000000000';
  orderColumn: string = "startDate";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  field: string = "startDate";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "date";
  client: string;
  employeeID: string | null;

}

export class returnClientAuthorization {
  id: string = '00000000-0000-0000-0000-000000000000';
  clientId: string = '00000000-0000-0000-0000-000000000000';
  startDate: string;
  endDate: string;
  companyId: string = '00000000-0000-0000-0000-000000000000';
  payerId: string = '00000000-0000-0000-0000-000000000000' ;
  insuranceNo: string;
  serviceAgreementNo: string;
  payerServiceMapId: number;
  serviceDescription: string;
  totalUnits: number;
  unitsUsed: number | null;
  unitsRemaining: number | null;
  companyName: string;
  payorName: string;
  serviceCode: string;
  serviceId: string = '00000000-0000-0000-0000-000000000000';

}


export class ClientAuthorizationBO {
  public id: string = '00000000-0000-0000-0000-000000000000';
  public clientId: number;
  public startDate: string;
  public endDate: string;
  public companyId:string = '00000000-0000-0000-0000-000000000000';
  public payerId: string = '00000000-0000-0000-0000-000000000000';
  public insuranceNo: number;
  public serviceAgreementNo: string;
  public payerServiceMapId: string = '00000000-0000-0000-0000-000000000000';
  public serviceDescription: string;
  public totalUnits: number;
  public unitsUsed: number;
  public unitsRemaining: number;
  public totalUnitsperday: string;
  public billingvalue: number;
  public netRate: number = null;
  public ucRate: number = null;
  public previouslyUsedUnit: number = null;
  public disableAuthorization: boolean
  public DisableAuthorization: boolean

  public authLimitType: string;
  public excludeAuth: string;
  masterserviceId: string = '00000000-0000-0000-0000-000000000000';
  modifier1:string|null;
  modifier2:string|null;
  modifier3:string|null;
  modifier4:string|null;
  serviceCode :string|null
}
export class EditDetailsAuthorization {
  isView: boolean = false;
  isEdit: boolean = false;
  isEditAuthorization: boolean = false;
  AuthorizationId: string = '00000000-0000-0000-0000-000000000000';
  AuthorizationData: ClientAuthorizationBO = new ClientAuthorizationBO();
  ClientId:string = '00000000-0000-0000-0000-000000000000';
  type: string = '';
  // state:string;
}

export class ClientSOC {
  public id: Guid;
  public clientId: Guid;
  public startDate: Date;
  public companyId: Guid;
  public dischargeLid: Guid;
  public dischargeDate: Date;
  public dischargeCodeDetailId: Guid;
  public description: string;
}

export class EditSOCDetails {
  isView: boolean = false;
  isEdit: boolean = false;
  isEditSOC: boolean = false;
  clientId: Guid;
  type = ""
  clientSOCData: StartOfCareBO = new StartOfCareBO();
}
export class SOCListBO {
  orderColumn: string = "CompanyName";
  orderType: string = "asc";
  pageitem: number = 10;
  clientId: Guid;
  ages: number;
  client: string;
  currentpageno: number = 1;

  field: string = "CompanyName";

  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  statusLid:Guid;
}




// Care
export class StartOfCareBO {
  id: Guid ;
  clientId: Guid;
  startDate: string;
  companyId: Guid;
  dischargeLid: Guid ;
  dischargeDate: string ;
  dischargeCodeDetailId: Guid ;
  description: string;
  dischargeCode: string;
  dischargeStatus: string;
  companyName: string;
}

export class carecoordinate {
  id: Guid;
  clientId: Guid;
  careCoordinatorId: Guid;
  careCoordinatorName: string;
  county: string;
  phoneNumber: string;
  fax: string;
  alternateFax: string;
  email: string;
  statusName: string;
  statusLid: number;
  isDeleted: boolean | null;
}
export class ClientCoordinatorRelationshipBO{
  id: Guid;
  clientId: Guid;
  careCoordinatorId: Guid;
  statusLid: Guid;
  isDeleted: boolean | null;
  deletedBy: number | null;
  deletedDate: string | null;
  deletedIp: string;
  referralId:  string = "00000000-0000-0000-0000-000000000000";
}
export class ClientfmsagencyrRelationshipBO{
  id: Guid;
  clientId: Guid;
  fmsAgencyId: Guid;
  statusLid: Guid;
  isDeleted: boolean | null;
  deletedBy: number | null;
  deletedDate: string | null;
  deletedIp: string;
  referralId:  string = "00000000-0000-0000-0000-000000000000";
}
export class ClienthhaagencyrRelationshipBO{
  id: Guid;
  clientId: Guid;
  hhAgencyId: Guid;
  statusLid: Guid;
  isDeleted: boolean | null;
  deletedBy: number | null;
  deletedDate: string | null;
  deletedIp: string;
  referralId:  string = "00000000-0000-0000-0000-000000000000";
}
export class CareCoordinatorInfoLst {
  alternateFax: string;
  coordinator_Name: string;
  county: string;
  email: string;
  fax: string;
  phoneNumber: string;
  activeDate:string;
}
export class FMSAgencyrInfoLst {
    id: string;
    providerName: string;
    npi: string;
    phoneNumber: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    contactName: string;
    email: string;
    fax: string;
    fmsFee: number | null;
    statusLId: string | null;
    statusLovName: string;
    activeDate: Date | string | null;
}
export class HHAgencyInfoLst{
    id: string;
    hhaName: string;
    address: string;
    apt: string;
    city: string;
    state: string;
    zipCode: string;
    phoneNumber: string;
    email: string;
    fax: string;
    statusLId: string | null;
    statusLovName: string;
    activeDate: Date | string | null;
}

export class GetClientCarecoordinator {
  orderColumn: string = "careCoordinatorName";
  orderType: string = "asc";
  pageitem: number = 10;
  clientId: Guid;
  ages: number;
  client: string;
  currentpageno: number = 1;
  field: string = "careCoordinatorName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  statusLid:Guid;
  referralId: Guid;
}
export class GetClientFMSAgency {
  orderColumn: string = "providerName";
  orderType: string = "asc";
  pageitem: number = 10;
  clientId: Guid;
  ages: number;
  client: string;
  currentpageno: number = 1;
  field: string = "providerName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  statusLid:Guid;
  referralId: Guid;
}
export class GetClientHHAAgency {
  orderColumn: string = "hhaName";
  orderType: string = "asc";
  pageitem: number = 10;
  clientId: Guid;
  ages: number;
  client: string;
  currentpageno: number = 1;
  field: string = "hhaName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  statusLid:Guid;
  referralId: Guid;
}
export class AssignCareCoordinator {
  id: Guid;
  clientId: Guid;
  careCoordinatorId:Guid;
  statusLid: Guid;
  activeDate:string;
  inActiveDate:string;
  referralId:  Guid;

}

export class AssignFMSAgency {
  id: Guid;
  clientId: Guid;
  fmsagencyId:Guid;
  statusLid: Guid;
  activeDate:string;
  inActiveDate:string;
  referralId:  Guid;

}
export class AssignHHAAgency {
  id: Guid;
  clientId: Guid;
  hhAgencyId:Guid;
  statusLid: Guid;
  activeDate:string;
  inActiveDate:string;
  referralId:  Guid;

}


export class AssignCaseManager {
  id: string = '00000000-0000-0000-0000-000000000000';
  clientId: string = '00000000-0000-0000-0000-000000000000';
  // statusLid: string = '00000000-0000-0000-0000-000000000000';
  caseManagerId:string = '00000000-0000-0000-0000-000000000000';
  activeDate:string;
  inActiveDate:string;
  referralId:  string = "00000000-0000-0000-0000-000000000000";

}


export class GetClientCasemanager {
  orderColumn: string = "CaseManagerName";
  orderType: string = "asc";
  pageitem: number = 10;
  clientId: string;
  ages: number;
  client: string;
  currentpageno: number = 1;
  field: string = "CaseManagerName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  statusLid:string="00000000-0000-0000-0000-000000000000";
  referralId:  string = "00000000-0000-0000-0000-000000000000";
}

export class getMappedCMDataBO {
  id:string="00000000-0000-0000-0000-000000000000";
  clientId:string="00000000-0000-0000-0000-000000000000";
  caseManagerId: string="00000000-0000-0000-0000-000000000000";
  caseManagerName: string;
  state: string;
  street: string;
  zip: string;
  county: string;
  phone: string;
  fax: string;
  alternateFax: string;
  email: string;
  statusName: string;
  statusLid: string="00000000-0000-0000-0000-000000000000";
  activeDate : string;
  inActiveDate : string
  // isDeleted: boolean | null;
 
}





export class ClientCaseManagerRelationshipBO {
  id:string ="00000000-0000-0000-0000-000000000000";
  clientId: string;
  statusLid: string="00000000-0000-0000-0000-000000000000";
  caseManagerId: number;
  activeDate:string;
  inActiveDate:string;
  referralId:  string = "00000000-0000-0000-0000-000000000000";
  // isDeleted: boolean | null;
  // deletedBy: number | null;
  // deletedDate: string | null;
  // deletedIp: string;
}


export class qpList {
  age: number;
  apt: string;
  city: string;
  county: string;
  email: string;
  name: string;
  phone1: string;
  phone2: string;
  steet: string;
  street: string;
  zipcode: string;
  activeDate:string; 
}
export class QPHistoryLst {
  currentStatus: string;
  id: Guid;
  lastModifiedBy: string;
  lastModifiedDate: string | null;
  mappedBy: string;
  mappedOn: string | null
  name: string;
}

// QP Info
export class ClientQpInfoBO {
  orderColumn: string = "clientName";
  orderType: string = "ASC";
  pageitem: number = 10;
  currentpageno: number = 1;
  field: string = "clientName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  employeeId: Guid;
  LocationID: Guid;
  clientId: Guid;
  AgencyID: Guid ;
  statusLid: Guid;
}

export class ClientCertificationBO {
  public id: Guid;
  public clientId: Guid;
  public startOfCareId: Guid;
  public startDate: any;
  public endDate: any;
  public companyId: Guid;
  public icD10PrimaryId: string;
  public icD10SecondaryId: string;
  public npi: string;
  public physician: string;
  public clinic: string;
  public firstDigitFacilityLid: string = null;
  public secondDigitFacilityLid: string = null;
  public frequncyCodeLid: string = null;
  public priorityTypeOfAdmissionLid: string = null;
  public pointOfOriginForAdmissionOrVisitLid: string = null;
  public patientDischargeStatusLid: string = null;
  clinicCity: string;
  clinicState: string;
  clinicAddress: string;
  clinicPhone: string;
  zipCode: string;
  public is837I: boolean = false;
  referringProvider_NPI: string;
  referringProvider_FirstName: string;
  referringProvider_LastName: string;
  referringProvider_MiddleName: string;
}

export interface PhysicianBO {
  id: Guid;
  nPI: string;
  physicianName: string;
  clinicName: string;
  clinicCity: string;
  clinicState: string;
  clinicAddress: string;
  clinicPhone: string;
  zipCode: string;
}
export class editcertificate {
  isView: boolean = false;
  isEdit: boolean = false;

  clientId: Guid;
  type = ""
  certificateId: number = 0;
  clientcertifcateData: ClientCertificationBO = new ClientCertificationBO();
}
export class returnStartOfCareWithCompany {
  startOfCareId: Guid;
  companyId: Guid;
  socDateWithCompanyName: string;
}

export class CertificationListBO {
  orderColumn: string = "CompanyName";
  orderType: string = "asc";
  pageitem: number = 10;
  clientId: Guid;
  ages: number;
  client: string;
  currentpageno: number = 1;
  field: string = "CompanyName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
}

export class GetPhysicanBO {
  orderColumn: string = "PhysicianName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: number;
  clientId: number | null;
  field: string = "PhysicianName";
  value: string = "";
  matchCase: boolean = false;
  type: string = "string";
  operator: string = "contains";
}

// Eligibility
export class GetEDI271ClientBO {
  orderColumn: string = "ClientName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: Guid;
  clientId: Guid | null;
  agencyId: Guid | null;
  field: string = "ClientName";
  value: string = "";
  matchCase: boolean = false;
  type: string = "string";
  operator: string = "contains";
  locationId: Guid | null;
}

export class EDI271ClientReportBO {
  clientIdQualifier: string;
  clientID: string;
  clientName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  dOB: string;
  gender: string;
  lastEligibilityCheck: string | null;
  clientPkId: Guid | null;
  medicaid: string;
  isMAEligible: boolean;
  pMAP: string;
  program: string;
  waiver: string;
  spendDown: boolean;
  mSHO: boolean;
  messageList: string[];
  messages: string;
  loopDetails: EDI271LoopDetailBO[];
  aAADetails: EDI271AAADetailBO[];
}
export class AuthorizationUtilizationBO
{
  processesorId: string=null;
  serviceTypeLid: string = "00000000-0000-0000-0000-000000000000";
  serviceTypeName: string;
  locationTypeLid: string = "00000000-0000-0000-0000-000000000000";
  locationName: string;
  clientId: string = "00000000-0000-0000-0000-000000000000";
  reportType: string=null;
  dateFiltertype: string=null;
  employeeIds: string[];
  orderColumn: string;
  field: string;
  value: string = "";
  matchCase: boolean=false;
  agencyID: string = "00000000-0000-0000-0000-000000000000";
  currentpageno: number = 1;
  pageitem: number = 10;
  locationID: string = "00000000-0000-0000-0000-000000000000";
  type: string = "string";
  orderType: string = "asc";
  operator: string = "contains";
}

export class UtilizationBO
{
  UtilizationLength:any=[];
  clientId:string = "00000000-0000-0000-0000-000000000000";
  serviceTypeLid:string = "00000000-0000-0000-0000-000000000000";
  isInsideClient:boolean=false;
  clientName:string="";
}

export class ClientAuthorizationReportBo {
  orderColumn: string = "clientName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  agencyId: string = "00000000-0000-0000-0000-000000000000";
  field: string = "clientName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "contains";
  type: string = "string";
  locationID: string = "00000000-0000-0000-0000-000000000000";
  isHousing: boolean=false;
  serviceTypeLid:string = "00000000-0000-0000-0000-000000000000";
  dateType:boolean=false;
}
export class PageIdentifyBo {
  isHousing:boolean=false;
  PageTypeLid:string = "00000000-0000-0000-0000-000000000000";
  PageIdentity:string=""
}

export class authpermission {
  authorizationcreate: boolean
  authorizationupdate :boolean
  clientbudgetcreate :boolean
  clientbudgetupdate:boolean
  clientcreate:boolean
  clientnotescreate:boolean
  clientnotesdelete:boolean
  clientnotesupdate:boolean
  clientpurchasecreate:boolean
  clientupdate:boolean
  contactcreate:boolean
  contactdelete:boolean
  contactupdate:boolean
  certificationcreate:boolean
  certificationdelete:boolean
  certificationupdate:boolean
  documentcreate:boolean
  documentupdate:boolean
  relationshiptaxpercentcreate:boolean
  relationshiptaxpercentdelete:boolean
  relationshiptaxpercentupdate:boolean
  releationshipcreate:boolean
  releationshipupdate:boolean
  startofcarecreate:boolean
  startofcaredelete:boolean
  startofcareupdate:boolean
}

export class CallBo{
  eventConfirmation : boolean = false;
  clientIds : string[] ;
}

export class Exportmonitorlist{
  monitorId: string | null;
  clientIds : string[] ;
  StatusLId : string;
  EmployeeId : string;
  AuthStatus : string | null;
  isCompleted : string;
  SearchColumn : string | null;
  SearchText : string | null;
  LanguageLIds :string[];

}